module.exports = __webpack_public_path__ + "img/shitang2.3e1bd6a2.png";